import * as React from 'react';
import Button from '@mui/material/Button';
import { Row, Form, Col } from 'react-bootstrap';
import FirstName from '../form/FirstName';
import LastName from '../form/LastName';
import City from '../form/City';
import State from '../form/State';
import Zip from '../form/Zip';
import Phone from '../form/Phone';
import Email from '../form/Email';
import OrganizationType from '../form/OrganizationType';
import Address from '../form/Address';
import { v1 } from 'uuid';

export default function ComprehensiveSearchStep2({
  state,
  onChange,
  onBlur,
  validated,
}) {
  return (
    <div className="question step-2">
      <h2>Contact Information</h2>
      <Form id="TrademarkForm" noValidate validated={validated}>
        <Form.Group
          controlId="individualOrgOrInd"
          className="comprehensiveSearch ownerTop"
        >
          <Form.Label>
            Please provide your contact information below. We will use this
            information to create your account and to alert you of the results
            of your Comprehensive Search Report order. This information may be
            updated at anytime through your online Trademark Genius account.
          </Form.Label>
        </Form.Group>
        <div className="polaroid">
          <div className="two-column-form">
            <Form.Group as={Row}>
              <Col sm={6}>
                <FirstName
                  id="firstName"
                  label="First Name"
                  value={state.firstName}
                  onChange={onChange}
                />
              </Col>
              <Col sm={6}>
                <LastName
                  id="lastName"
                  label="Last Name"
                  value={state.lastName}
                  onChange={onChange}
                />
              </Col>
              <Col sm={6}>
                <Phone
                  id="phone"
                  label="Phone"
                  state={state}
                  onChange={onChange}
                />
              </Col>
              <Col sm={6}>
                <Email
                  id="email"
                  label="Email"
                  state={state}
                  onChange={onChange}
                  onBlur={onBlur}
                />
              </Col>
            </Form.Group>
          </div>
        </div>
      </Form>
    </div>
  );
}
